var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormFieldsContainer",
    [
      _c(
        "v-form",
        { ref: "form", attrs: { "lazy-validation": "" } },
        [
          _c("h2", { staticClass: "mt-2" }, [_vm._v("Costos De Importación")]),
          _c(
            "v-layout",
            { staticClass: "ml-1", attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3 mb-2",
                    attrs: { label: _vm.formFields.clausula.label },
                    model: {
                      value: _vm.formFields.clausula.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.clausula, "value", $$v)
                      },
                      expression: "formFields.clausula.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3",
                    attrs: { label: _vm.formFields.tipo_flete.label },
                    model: {
                      value: _vm.formFields.tipo_flete.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.tipo_flete, "value", $$v)
                      },
                      expression: "formFields.tipo_flete.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3",
                    attrs: { label: _vm.formFields.observacion.label },
                    model: {
                      value: _vm.formFields.observacion.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.observacion, "value", $$v)
                      },
                      expression: "formFields.observacion.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3 mb-2",
                    attrs: {
                      label: _vm.formFields.precioDolar.label,
                      hint: "Para decimales usar coma",
                      rules: [_vm.rules.numeric]
                    },
                    on: {
                      blur: function($event) {
                        _vm.formFields.precioDolar.value = _vm.formatNumber(
                          _vm.formFields.precioDolar.value
                        )
                      }
                    },
                    model: {
                      value: _vm.formFields.precioDolar.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.precioDolar, "value", $$v)
                      },
                      expression: "formFields.precioDolar.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3",
                    attrs: {
                      label: _vm.formFields.tCAduana.label,
                      hint: "Para decimales usar coma",
                      rules: [_vm.rules.numeric],
                      suffix: "CLP"
                    },
                    on: {
                      blur: function($event) {
                        _vm.formFields.tCAduana.value = _vm.formatNumber(
                          _vm.formFields.tCAduana.value,
                          true
                        )
                      }
                    },
                    model: {
                      value: _vm.formFields.tCAduana.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.tCAduana, "value", $$v)
                      },
                      expression: "formFields.tCAduana.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3",
                    attrs: {
                      label: _vm.formFields.flete.label,
                      hint: "Para decimales usar coma",
                      rules: [_vm.rules.numeric],
                      suffix: "CLP"
                    },
                    on: {
                      blur: function($event) {
                        _vm.formFields.flete.value = _vm.formatNumber(
                          _vm.formFields.flete.value
                        )
                      }
                    },
                    model: {
                      value: _vm.formFields.flete.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.flete, "value", $$v)
                      },
                      expression: "formFields.flete.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3",
                    attrs: {
                      label: _vm.formFields.fleteLocal.label,
                      hint: "Para decimales usar coma",
                      rules: [_vm.rules.numeric],
                      suffix: "CLP"
                    },
                    on: {
                      blur: function($event) {
                        _vm.formFields.fleteLocal.value = _vm.formatNumber(
                          _vm.formFields.fleteLocal.value
                        )
                      }
                    },
                    model: {
                      value: _vm.formFields.fleteLocal.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.fleteLocal, "value", $$v)
                      },
                      expression: "formFields.fleteLocal.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3",
                    attrs: {
                      label: _vm.formFields.desconsolidacion.label,
                      hint: "Para decimales usar coma",
                      rules: [_vm.rules.numeric],
                      suffix: "CLP"
                    },
                    on: {
                      blur: function($event) {
                        _vm.formFields.desconsolidacion.value = _vm.formatNumber(
                          _vm.formFields.desconsolidacion.value
                        )
                      }
                    },
                    model: {
                      value: _vm.formFields.desconsolidacion.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.desconsolidacion, "value", $$v)
                      },
                      expression: "formFields.desconsolidacion.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3",
                    attrs: {
                      label: _vm.formFields.derechos.label,
                      hint: "Para decimales usar coma",
                      rules: [_vm.rules.numeric],
                      suffix: "CLP"
                    },
                    on: {
                      blur: function($event) {
                        _vm.formFields.derechos.value = _vm.formatNumber(
                          _vm.formFields.derechos.value
                        )
                      }
                    },
                    model: {
                      value: _vm.formFields.derechos.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.derechos, "value", $$v)
                      },
                      expression: "formFields.derechos.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3",
                    attrs: {
                      label: _vm.formFields.almacenaje.label,
                      hint: "Para decimales usar coma",
                      rules: [_vm.rules.numeric],
                      suffix: "CLP"
                    },
                    on: {
                      blur: function($event) {
                        _vm.formFields.almacenaje.value = _vm.formatNumber(
                          _vm.formFields.almacenaje.value
                        )
                      }
                    },
                    model: {
                      value: _vm.formFields.almacenaje.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.almacenaje, "value", $$v)
                      },
                      expression: "formFields.almacenaje.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3",
                    attrs: {
                      label: _vm.formFields.agencia.label,
                      hint: "Para decimales usar coma",
                      rules: [_vm.rules.numeric],
                      suffix: "CLP"
                    },
                    on: {
                      blur: function($event) {
                        _vm.formFields.agencia.value = _vm.formatNumber(
                          _vm.formFields.agencia.value
                        )
                      }
                    },
                    model: {
                      value: _vm.formFields.agencia.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.agencia, "value", $$v)
                      },
                      expression: "formFields.agencia.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3",
                    attrs: {
                      label: _vm.formFields.seguro.label,
                      hint: "Para decimales usar coma",
                      rules: [_vm.rules.numeric],
                      suffix: "CLP"
                    },
                    on: {
                      blur: function($event) {
                        _vm.formFields.seguro.value = _vm.formatNumber(
                          _vm.formFields.seguro.value
                        )
                      }
                    },
                    model: {
                      value: _vm.formFields.seguro.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.seguro, "value", $$v)
                      },
                      expression: "formFields.seguro.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3",
                    attrs: {
                      label: _vm.formFields.cantidadCargados.label,
                      disabled: ""
                    },
                    model: {
                      value: _vm.cantidadCargados,
                      callback: function($$v) {
                        _vm.cantidadCargados = $$v
                      },
                      expression: "cantidadCargados"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3",
                    attrs: {
                      label: _vm.formFields.totalOtros.label,
                      disabled: ""
                    },
                    model: {
                      value: _vm.formFields.totalOtros.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.totalOtros, "value", $$v)
                      },
                      expression: "formFields.totalOtros.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3",
                    attrs: {
                      label: _vm.formFields.costoUnitarioInternacion.label,
                      suffix: "CLP",
                      disabled: ""
                    },
                    model: {
                      value: _vm.formFields.costoUnitarioInternacion.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formFields.costoUnitarioInternacion,
                          "value",
                          $$v
                        )
                      },
                      expression: "formFields.costoUnitarioInternacion.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c(
                    "v-text-field",
                    {
                      staticClass: "mb-3",
                      attrs: {
                        label: _vm.formFields.precioCompra.label,
                        suffix: "CLP",
                        disabled: "",
                        readonly: ""
                      },
                      model: {
                        value: _vm.formFields.precioCompra.value,
                        callback: function($$v) {
                          _vm.$set(_vm.formFields.precioCompra, "value", $$v)
                        },
                        expression: "formFields.precioCompra.value"
                      }
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { slot: "append", value: true, bottom: "" },
                          slot: "append",
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "v-icon",
                                    _vm._g(
                                      { attrs: { color: "grey", dark: "" } },
                                      on
                                    ),
                                    [_vm._v(" search ")]
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "Costo de compra original corresponde a la suma del costo\n              unitario de las series ingresadas."
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mr-2 mb-3",
                    attrs: {
                      label: _vm.formFields.precioTotal.label,
                      suffix: "CLP",
                      disabled: ""
                    },
                    model: {
                      value: _vm.formFields.precioTotal.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.precioTotal, "value", $$v)
                      },
                      expression: "formFields.precioTotal.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }